module.exports = __webpack_public_path__ + "static/media/analysis1.04d2e35b.png";